import * as React from 'react';

import { Box } from '@rbilabs/components-library/build/components/layout';

import { useStoreActionOptions } from '../store-actions/hooks/use-store-action-options';

import { ImprovedStoreCardDetails, StoreCardActions, StoreCardError } from './components';
import { StoreCaption } from './store-caption';
import { FadeIn, StoreHeader, Subtitle2 } from './store-card.styled';
import { NewStoreCardViewProps } from './types';

export const StoreCardView: React.FC<NewStoreCardViewProps> = ({
  isFavorite = false,
  isUpdatingFavorites = false,
  onDiagnosticsClick,
  onFavoriteClick,
  storeDetails,
  restaurant,
}) => {
  const actionOptions = useStoreActionOptions({ restaurant });

  return (
    <>
      <FadeIn>
        <Box
          background={Styles.color.cardBackground}
          padding="0.5rem 0.75rem"
          position="relative"
          overflow="hidden"
          minHeight="96px"
          flexDirection="column"
        >
          <StoreHeader>
            {storeDetails.title && <Subtitle2>{storeDetails.title.toLowerCase()}</Subtitle2>}

            <StoreCardActions
              favoriteIcon={isFavorite}
              onDiagnosticsClick={onDiagnosticsClick}
              onFavoritesClick={onFavoriteClick}
              isUpdatingFavorites={isUpdatingFavorites}
            />
          </StoreHeader>

          <ImprovedStoreCardDetails
            storeActionOptions={actionOptions}
            caption={<StoreCaption storeDetails={storeDetails} />}
            body={storeDetails.body}
            errorMessage={
              storeDetails.errorMessage ? (
                <StoreCardError message={storeDetails.errorMessage} />
              ) : null
            }
            inStoreLoyalty={storeDetails.inStoreLoyalty}
            mobileLoyalty={storeDetails.mobileLoyalty}
            restaurant={restaurant}
          />
        </Box>
      </FadeIn>
    </>
  );
};
